'use client'
import { Col, Container, Image, Row } from "react-bootstrap";

import { useAppContext } from "@/helpers/context/AppContext";
import { contentEn, contentId, socmedGF, venueEn, venueId } from "@/constants";
import parse from 'html-react-parser';
import { useRouter } from "next/navigation";
import { useMediaQuery } from "react-responsive";
import FooterVenue from "@/components/FooterVenue";
import NavbarLanding from "@/components/NavbarLanding";
import ItemVenue from "@/components/ItemVenue";
import ItemVenueMobile from "@/components/ItemVenueMobile";

export default function Home() {
  const router = useRouter();
  const context = useAppContext();

  const isDesktop = useMediaQuery({
    query: '(min-width: 1224px)'
  })
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 991.98px)' })
    
  return (
    <>
      <NavbarLanding/>
      <Container>
        <Row className="section-hero justify-content-between">
          <Col lg={5} className="px-sm-5">
            <h2 className="title text-blue fm-russo-one fs-lg-1 lh-1 mb-4 text-end">
              { context.lang === 1 ?
                parse(contentId.homeTitle.replace(/^(\S+)/, '$1<br/>'))
                :
                parse(contentEn.homeTitle.replace(/^(\S+)/, '$1<br/>'))
              }
            </h2>
            <p className="desc text-gold fw-medium">
              { context.lang === 1 ?
                parse(contentId.homeDesc)
                :
                parse(contentEn.homeDesc)
              }
            </p>
          </Col>
        </Row>
        { isDesktop &&
          <Row className="section-venue mb-5">
            <ItemVenue data={venueId}/>
          </Row>
        }
        { isTabletOrMobile &&
          <Row className="section-venue-mobile mb-5">
            <ItemVenueMobile data={venueId}/>
          </Row>
        }
      </Container>
      {/* { isDesktop && */}
        <FooterVenue data={socmedGF} landing={true}/>
      {/* } */}
    </>
  );
}
